import { api } from '@/core/api/';
import moment from 'moment';

const BASE_URL = '/api/erp-integration-log';
const DATE_FORMAT = 'YYYY-MM-DD';

export const searchErpIntegrationLog = async ({
  operation = null,
  startDate = null,
  endDate = null,
  correlationId = '',
  pageIndex = 1,
  pageSize = 15,
} = {}) => {
  const { data } = await api.get(`${BASE_URL}/search`, {
    params: {
      operation,
      startDate: startDate ? moment(startDate).format(DATE_FORMAT) : null,
      endDate: endDate ? moment(endDate).format(DATE_FORMAT) : null,
      correlationId: correlationId || null,
      pageIndex,
      pageSize,
    },
  });
  return data;
};

export const getErpOperations = async () => {
  const { data } = await api.get(`${BASE_URL}/operations`);
  return data;
};

export const getErpSteps = async (operationTraceId) => {
  const { data } = await api.get(`${BASE_URL}/${operationTraceId}/steps`);
  return data;
};
